import { Button, Row, Tag, Tooltip, Typography } from 'antd';
import type { ColumnType, ColumnsType } from 'antd/es/table';
import { EyeOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

import Table from '../../../../components/general/table';
import { ExportExcelProps } from '../../../../helpers/excel';
import { ExportPdfProps } from '../../../../helpers/pdf';
import { Service } from '../../../../api/models/services';
import DeveloperForm from '../detail';

const label = 'desarrollador';
const route = '/developers';
const titlePdf = 'Reporte de desarrolladores';
const scrollTable = 300;
type GenerateTableColumnProps = {
  getColumnSearchProps: (propName: string) => ColumnType<Service>;
  showModal: (type: string, id: number | null) => void;
  handleDelete: (id: number) => void;
};

const DevelopersList = () => {
  const { Text } = Typography;

  const generateTableColumns: (
    props: GenerateTableColumnProps
  ) => ColumnsType<Service> = (props) => {
    const { getColumnSearchProps, showModal, handleDelete } = props;

    return [
      {
        title: 'Nombre',
        width: 100,
        ellipsis: true,
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        render: (name) => (
          <>
            {name && (
              <Text>{name.charAt(0).toUpperCase() + name.slice(1)}</Text>
            )}
          </>
        ),
      },
      {
        title: 'Acciones',
        key: 'sup',
        fixed: 'right',
        width: 50,
        align: 'center',
        render: (contact) => (
          <>
            <Tooltip title="Ver más información">
              <Button
                type="primary"
                ghost
                shape="circle"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => showModal('watch', contact.id)}
              />
            </Tooltip>
            {/* <CanShow roles={['ADMIN', 'MANAGEMENT']}>
              <> */}
            <Tooltip title="Editar">
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#537896',
                  borderColor: '#537896',
                }}
                type="primary"
                shape="circle"
                size="small"
                icon={<EditOutlined />}
                onClick={() => showModal('edit', contact.id)}
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#e63241',
                  borderColor: '#cf1322',
                }}
                type="primary"
                shape="circle"
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(contact.id)}
              />
            </Tooltip>
            {/* </>
            </CanShow> */}
          </>
        ),
      },
    ];
  };

  const generateExportExcelProps: () => ExportExcelProps = () => ({
    fileName: 'Reporte_Desarrolladores',
    sheetName: 'Desarrolladores',
    tableName: 'Tabla de Desarrolladores',
    columnNames: [
      { label: 'ID', key: 'id' },
      { label: 'Nombre', key: 'name' },
    ],
  });

  const pdfColumns: ExportPdfProps[] = [
    { header: 'ID', key: 'id' },
    { header: 'Nombre', key: 'name' },
  ];
  const developerTableProps = {
    label,
    route,
    generateTableColumns,
    generateExportExcelProps,
    detailForm: DeveloperForm,
    pdfColumns,
    titlePdf,
    scrollTable,
  };
  const DevelopersTable = Table<Service>(developerTableProps);

  return DevelopersTable;
};

export default DevelopersList;
